<template>
  <dialog-view :open="open" title="Обращение" @cancel="close()" contentFullSize>
    <template v-slot:content>
      <div class="ma-3">
        <autocomplete-single
            name="Цель обращения"
            :items="callTargets"
            :select.sync="callTarget"
            @update:select="callTargetUpdate"
        >
          <template v-slot:no-data>
            <div class="caption text-center">Не найдено</div>
          </template>
          <template v-slot:item="{item}">
            <v-sheet max-width="189">
              <v-row no-gutters class="align-center">
                <v-col class="body-2 py-2 pr-2">
                  {{item.name}}
                </v-col>
                <v-col cols="auto">
                  <tooltip-view bottom :content="item.comment">
                    <template v-slot:action>
                      <v-icon small color="grey" class="mr-2">mdi-comment-text-outline</v-icon>
                    </template>
                  </tooltip-view>
                </v-col>
              </v-row>
            </v-sheet>
          </template>
          <template v-slot:selection="{item}">{{item.name}}</template>
        </autocomplete-single>

        <autocomplete-single
            name="Результат обращения"
            :items="callTarget===null ? [] : callTarget.callResults"
            :select.sync="callResult"
            :disabled="callTarget===null"
            @update:select="callResultUpdate"
        >
          <template v-slot:no-data>
            <div class="caption text-center">Не найдено</div>
          </template>
          <template v-slot:itemIcon="{item}">
            <v-avatar v-if="item.type==='success'" color="success" size="16" class="mr-2"><v-icon color="white" size="12">mdi-check</v-icon></v-avatar>
            <v-avatar v-else-if="item.type==='info'" color="blue" size="16" class="mr-2"><v-icon color="white" size="20">mdi-information-symbol</v-icon></v-avatar>
            <v-avatar v-else color="red" size="16" class="mr-2"><v-icon color="white" size="12">mdi-close</v-icon></v-avatar>
          </template>
          <template v-slot:selectedInfo="{item}">
            <v-avatar v-if="item.type==='success'" color="success" size="16" style="margin-top:-10px" class="mr-2"><v-icon color="white" size="12">mdi-check</v-icon></v-avatar>
            <v-avatar v-else-if="item.type==='info'" color="blue" size="16" style="margin-top:-2px" class="mr-2"><v-icon color="white" size="20">mdi-information-symbol</v-icon></v-avatar>
            <v-avatar v-else color="red" size="16" class="mr-2"><v-icon color="white" size="12">mdi-close</v-icon></v-avatar>
            <span class="text-no-wrap">{{item.name}}</span>
          </template>
        </autocomplete-single>
      </div>
    </template>
  </dialog-view>
</template>

<script>
import DialogView from "@/components/DialogView.vue";
import AutocompleteSingle from "@/componentsV2/base/AutocompleteSingle.vue";
import TooltipView from "@/components/TooltipView.vue";
import axios from "axios";
import {Entity_CallResult, Entity_CallTarget} from "../../../../../EntityStoreCacheService";

export default {
  components: {DialogView, AutocompleteSingle, TooltipView},
  props: ['open', 'chat'],
  data: () => ({
    callTargets: [],
    callTarget: null,
    callResult: null,
  }),
  watch: {
    open(v) {
      if (v) this.reset();
    },
    callTargets() {
      if (this.open) this.reset();
    },
  },
  mounted() {
    this.loadCallTargets();
  },
  methods: {
    loadCallTargets() {
      new Entity_CallTarget()
          .selects(Entity_CallTarget.id)
          .selects(Entity_CallTarget.name)
          .selects(Entity_CallTarget.comment)
          .selects([Entity_CallTarget.callResults, Entity_CallResult.id].join('.'))
          .selects([Entity_CallTarget.callResults, Entity_CallResult.name].join('.'))
          .selects([Entity_CallTarget.callResults, Entity_CallResult.type].join('.'))
          .selects([Entity_CallTarget.callResults, Entity_CallResult.comment].join('.'))
          .order(Entity_CallTarget.sort, true)
          .order([Entity_CallTarget.callResults, Entity_CallResult.sort].join('.'), true)
          .page(1)
          .onPage(1000)
          .addStateCallback((state) => {
            if (state.success)
              this.callTargets = state.items;
          })
          .request();
    },
    reset() {
      if (this.chat?.callTarget === null || this.chat?.callTarget === undefined)
        this.callTarget = null;
      else {
        this.callTarget = null;
        this.callTargets.forEach(v => {
          if (this.chat.callTarget.id === v.id)
            this.callTarget = v;
        });
      }

      if (this.chat?.callResult === null || this.chat?.callResult === undefined)
        this.callResult = null;
      else {
        this.callResult = null;
        this.callTargets.forEach(v => {
          v.callResults.forEach(v1 => {
            if (this.chat.callResult.id === v1.id)
              this.callResult = v1;
          });
        });
      }
    },
    close() {
      this.reset();
      this.$emit('cancel');
    },
    callTargetUpdate(v) {
      if (this.chat === null || this.chat.callTarget?.id === v?.id)
        return;

      if (v === null) {
        this.chat.callTarget = null;
        this.callResult = null;
      }

      axios.put('/napi/dialog/chat/' + this.chat.id + '/callTarget/', {
        id: v === null ? null : v.id
      });
      this.chat.callTarget = v;
      this.callResult = null;
    },
    callResultUpdate(v) {
      if (this.chat === null || this.chat.callResult?.id === v?.id)
        return;

      axios.put('/napi/dialog/chat/' + this.chat.id + '/callResult/', {
        id: v === null ? null : v.id
      });
      this.chat.callResult = v;
    },
  },
}
</script>
